import ChevronLeft from '@sats-group/icons/24/arrow-left';
import ChevronRight from '@sats-group/icons/24/arrow-right';
import Button from '@sats-group/ui-lib/react/button/button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import useCounter from '~/client/hooks/use-counter';
import type { Slideshow as Props } from './slideshow.types';

const Slideshow: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  initialSlide = 0,
  nextButtonText,
  previousButtonText,
}) => {
  const slidesCount = React.Children.count(children);
  const maxIndex = slidesCount - 1;
  const [current, next, previous] = useCounter(0, maxIndex, initialSlide);

  const trackStyle = { transform: `translateX(${-current * 100}%)` };

  return (
    <div className="slideshow">
      <div className="slideshow__track-container">
        <div className="slideshow__track" style={trackStyle}>
          {React.Children.map(children, child => (
            <div className="slideshow__slide">{child}</div>
          ))}
        </div>
      </div>
      <div className="slideshow__nav">
        <Button
          aria-label={previousButtonText}
          disabled={current === 0}
          iconOnly
          leadingIcon={<ChevronLeft />}
          onClick={previous}
          text={previousButtonText}
          variant="secondary"
        />
        <Text elementName="span">{`${current + 1}/${slidesCount}`}</Text>
        <Button
          aria-label={nextButtonText}
          disabled={current === maxIndex}
          iconOnly
          leadingIcon={<ChevronRight />}
          onClick={next}
          text={nextButtonText}
          variant="secondary"
        />
      </div>
    </div>
  );
};

export default Slideshow;
